
import QuestionTimer from './question-timer.vue'
import QuestionVerticalSelect from './question-vertical-select.vue'

export default {
  components: {QuestionTimer, QuestionVerticalSelect},
  props: {
    question: {type: Object, default: undefined}
  },
  emits: ['prompt', 'answer-ai'],
  data() {
    return {
      timer_done: false
    }
  },
  computed: {
    type() {
      return this.question.type
    },
    title() {
      return this.question.title
    },
    items() {
      return this.question.items
    },
    on_skip() {
      return this.question.on_skip
    },
  },
  methods: {
    disableTimer(){
      this.$refs.timer?.disableTimer()
    },
    onAnswer(chat_query) {
      this.disableTimer()
      this.$emit('answer-ai', chat_query)
    }
  }
}
